<template>
  <div>
    <b-form-checkbox
      id="checkbox-1"
      v-model="pdfAction"
      name="checkbox-1"
      class="mt-2"
      :value="true"
      :unchecked-value="false"
      switch
      @input="updateActions"
    >
      ผู้เรียนจะได้รับประกาศนียบัตรเมื่อจบคอร์ส
    </b-form-checkbox>
    <b-collapse v-if="comId == 473" v-model="pdfAction" class="mt-4">
      <b-row style="display: flex; align-items: center;" class="mt-2 mb-4">
        <b-col cols="4">
          <b-form-checkbox
            id="checkbox-certificate-levels"
            name="checkbox-certificate-levels"
            v-model="useCertificateLevels"
            :value="true"
            :unchecked-value="false"
            style="padding-left: 3.7rem;"
            @change="handleCertificateLevels"
          >
            กำหนดช่วงคะแนนของการได้รับประกาศนียบัตร
          </b-form-checkbox>
        </b-col>
        <b-col cols="4" style="display: flex;" v-if="useCertificateLevels && posttestLectureName">
          <span style="white-space: nowrap; display: flex; align-items: center; margin-bottom: 0rem !important;">แบบทดสอบหลังเรียน</span>
          <b-input class="ml-2" :value="posttestLectureName" disabled/>
        </b-col>
      </b-row>
      <div v-if="useCertificateLevels && posttestLectureName">
        <b-row class="mb-3" style="padding-left: 2.25rem;">
          <b-col cols="3">
            ช่วงเปอร์เซ็นต์ของคะแนน
          </b-col>
          <b-col cols="3">
            ระดับประกาศนียบัตร
          </b-col>
        </b-row>

        <b-row
          v-for="(level, index) in certificateLevels"
          :key="index"
          class="mb-2 align-items-center"
          style="padding-left: 2.25rem;"
        >
          <b-col cols="3">
            <div class="d-flex align-items-center">
              <b-form-input
                v-model="level.lowerBoundRange"
                type="number"
                size="sm"
                min="0"
                max="100"
                @change="updateCertificateLevels"
                :class="{ 'invalid': validateCertificateLevel(index) === false }"
                style="width: 80px;"
              />
              <span class="mx-2">ถึง</span>
              <b-form-input
                v-model="level.upperBoundRange"
                type="number"
                size="sm"
                min="0"
                max="100"
                @change="updateCertificateLevels"
                :class="{ 'invalid': validateCertificateLevel(index) === false }"
                style="width: 80px;"
              />
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-select
              v-model="level.certLevel"
              :options="getAvailableLevelOptions(index)"
              size="sm"
              @change="updateCertificateLevels"
            />
          </b-col>
          <b-col cols="1">
            <b-button
              variant="danger"
              size="sm"
              @click="deleteCertificateLevel(index)"
              v-if="certificateLevels.length > 1"
            >
              <b-icon icon="trash"></b-icon>
            </b-button>
          </b-col>
        </b-row>

        <b-row class="mt-3" style="padding-left: 2.25rem;">
          <b-col>
            <b-button
              variant="primary"
              size="sm"
              @click="addCertificateLevel"
              :disabled="certificateLevels.length >= 6"
            >
              <b-icon icon="plus" size="lg"></b-icon>
              เพิ่มระดับประกาศนียบัตร
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div class="mt-4" style="padding-left: 2.3rem;" v-else-if="useCertificateLevels">
          <p class="not-have-post-test">ไม่มีแบบทดสอบหลังเรียน กรุณาเลือกแบบทดสอบในขั้นตอนที่ 2 : เนื้อหาคอร์ส</p>
      </div>
    </b-collapse>

    <b-form-textarea
      v-show="false"
      id="textarea"
      class="mt-4"
      :value="courseCompleteActionsText"
      rows="3"
      max-rows="5"
      disabled
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CertificateSetting",
  props: {
    initialPdfAction: {
      type: Boolean,
      default: false
    },
    initialUseCertificateLevels: {
      type: Boolean,
      default: false
    },
    initialCertificateLevels: {
      type: Array,
      default: () => []
    },
    isInitializing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      comId: JSON.parse(localStorage.getItem("ComId")),
      courseId: this.$route.params.courseId,
      pdfAction: this.initialPdfAction,
      useCertificateLevels: this.initialUseCertificateLevels,
      certificateLevels: [...this.initialCertificateLevels],
      certificateLevelOptions: [
        { value: 'PLATINUM', text: 'Platinum' },
        { value: 'PREMIUM_GOLD', text: 'Premium Gold' },
        { value: 'GOLD', text: 'Gold' },
        { value: 'SILVER', text: 'Silver' },
        { value: 'BLUE', text: 'Blue' },
        { value: 'BRONZE', text: 'Bronze' }
      ],
    };
  },
  computed: {
    ...mapGetters("CourseManagement", [
      "courseCertificateLevels",
      "courseModuleList",
      "hasQuizLecturePosttestFlag"
    ]),
    ...mapGetters("CourseCompleteRule", [
      "courseCompleteActions",
    ]),
    courseCompleteActionsText() {
      let actions = this.courseCompleteActions
        .filter((item) => item.action !== "PDF")
        .map((item) => {
          return item.action;
        });
      return actions.join();
    },
    posttestLectureName() {
      if (!this.courseModuleList) return null;
      if (!this.hasQuizLecturePosttestFlag) return null;
       
      const posttestLectures = [];
      this.courseModuleList.forEach(module => {
        if (module.lectures) {
          const posttests = module.lectures.filter(lecture => 
            lecture.quizLectureFlag === "POSTTEST"
          );
          posttestLectures.push(...posttests);
        }
      });
       
      return posttestLectures.length > 0 ? posttestLectures[0].lectureName : null;
    },
  },
  watch: {
    initialPdfAction(newVal) {
      this.pdfAction = newVal;
    },
    initialUseCertificateLevels(newVal) {
      this.useCertificateLevels = newVal;
    },
    initialCertificateLevels(newVal) {
      this.certificateLevels = [...newVal];
    }
  },
  async created() {
    await this.fetchCourseModulesList({courseId: this.courseId}).then(() => {});
    await this.fetchCourseCertificateLevels({courseId: this.courseId}).then(() => {});
    
    this.certificateLevels = this.courseCertificateLevels?.cert_levelCondition?.condition;
    this.useCertificateLevels = this.courseCertificateLevels?.cert_levelCondition?.condition.length > 0;
  },
  methods: {
    ...mapActions("CourseManagement", [
      "fetchCourseModulesList",
      "fetchCourseCertificateLevels",
      "updateCourseCertificateLevels",
      "getCourseInfo"
    ]),
    ...mapActions("CourseCompleteRule", [
      "updateCourseCompleteActions",
    ]),

    async updateActions() {
      if (this.isInitializing) return;
      
      this.$emit('update:pdfAction', this.pdfAction);
      
      await this.updateCourseCompleteActions({
        courseId: this.courseId,
        hasPdfAction: this.pdfAction,
      });

      if (this.pdfAction == false) this.useCertificateLevels = false;
      
      this.$emit('actions-updated');
      await this.handleCertificateLevels();
    },

    validateCertificateLevel(levelIndex) {
      const level = this.certificateLevels[levelIndex];
      if (!level) return null;
      
      // Check for invalid numeric strings before conversion
      const lowerStr = String(level.lowerBoundRange).trim();
      const upperStr = String(level.upperBoundRange).trim();
      
      // Only accept positive integers (0-100)
      if (!/^\d+$/.test(lowerStr) || !/^\d+$/.test(upperStr)) {
        return false;
      }
      
      const lower = Number(level.lowerBoundRange);
      const upper = Number(level.upperBoundRange);
      
      // Check for NaN values
      if (isNaN(lower) || isNaN(upper)) {
        return false;
      }
      
      // Check basic range validity
      if (lower < 0 || lower > 100 || upper < 0 || upper > 100) {
        return false;
      }
      
      // Check if lower is greater than upper (only mark this level red)
      if (lower > upper) {
        return false;
      }
      
      // Find nearest levels (one directly above and one directly below in score range)
      let levelAbove = null; // Level with lower bound closest to and greater than current upper
      let levelBelow = null; // Level with upper bound closest to and less than current lower
      
      if (levelIndex != this.certificateLevels.length - 1) {
        levelBelow = this.certificateLevels[levelIndex + 1];
      }
      
      if (levelIndex != 0) {
        levelAbove = this.certificateLevels[levelIndex - 1];
      }
      
      // Check for gaps or overlaps with nearest adjacent levels only
      if (levelAbove) {
        const aboveLower = Number(levelAbove.lowerBoundRange);
        const aboveUpper = Number(levelAbove.upperBoundRange);
        
        // Check for overlap with level above
        if ((lower >= aboveLower && lower <= aboveUpper) || 
            (upper >= aboveLower && upper <= aboveUpper) ||
            (lower <= aboveLower && upper >= aboveUpper)) {
          return false;
        }
        
        // Check for gap with level above (should be adjacent: upper + 1 = aboveLower)
        if (upper + 1 !== aboveLower) {
          return false;
        }
      }
      
      if (levelBelow) {
        const belowLower = Number(levelBelow.lowerBoundRange);
        const belowUpper = Number(levelBelow.upperBoundRange);
        
        // Check for overlap with level below
        if ((lower >= belowLower && lower <= belowUpper) || 
            (upper >= belowLower && upper <= belowUpper) ||
            (lower <= belowLower && upper >= belowUpper)) {
          return false;
        }
        
        // Check for gap with level below (should be adjacent: lower - 1 = belowUpper)
        if (lower - 1 !== belowUpper) {
          return false;
        }
      }
      
      return null;
    },

    hasValidationErrors() {
      if (!this.certificateLevels) return false;
      for (let i = 0; i < this.certificateLevels.length; i++) {
        if (this.validateCertificateLevel(i) === false) {
          return true;
        }
      }
      return false;
    },

    getAvailableLevelOptions(currentIndex) {
      const usedLevels = this.certificateLevels
        .map((level, index) => index !== currentIndex ? level.certLevel : null)
        .filter(certLevel => certLevel !== null);
      
      return this.certificateLevelOptions.filter(
        option => !usedLevels.includes(option.value)
      );
    },

    getNextAvailableLevel() {
      const usedLevels = this.certificateLevels.map(level => level.certLevel);
      const availableLevel = this.certificateLevelOptions.find(
        option => !usedLevels.includes(option.value)
      );
      return availableLevel ? availableLevel.value : 'BRONZE';
    },

    getNextIndex() {
      if (this.certificateLevels.length === 0) return 1;
      const maxIndex = Math.max(...this.certificateLevels.map(level => level.index));
      return maxIndex + 1;
    },

    addCertificateLevel() {
      const nextLevel = this.getNextAvailableLevel();
      const nextIndex = this.getNextIndex();
      
      let lowerBound, upperBound;
      
      if (this.certificateLevels.length === 0) {
        // First time: use 0 - 100
        lowerBound = 0;
        upperBound = 100;
      } else {
        // Get the last level (highest index)
        const lastLevel = this.certificateLevels.reduce((prev, current) => 
          (prev.index > current.index) ? prev : current
        );
        
        const lastLowerBound = Number(lastLevel.lowerBoundRange);

        
        const newUpperBoundRange = Math.max(1, Math.floor(lastLowerBound - 1));
        const newLowerBoundRange = Math.max(0, Math.floor(lastLowerBound * 0.75));
        
        
        lastLevel.lowerBoundRange = Math.max(1, Math.floor(lastLowerBound));

        lowerBound = newLowerBoundRange;
        upperBound = newUpperBoundRange;
      }
      
      this.certificateLevels.push({
        index: nextIndex,
        lowerBoundRange: lowerBound,
        upperBoundRange: upperBound,
        certLevel: nextLevel
      });
      this.updateCertificateLevels();
    },

    deleteCertificateLevel(index) {
      if (this.certificateLevels.length <= 1) return;
      
      const deletedLevel = this.certificateLevels[index];
      const deletedLower = Number(deletedLevel.lowerBoundRange);
      const deletedUpper = Number(deletedLevel.upperBoundRange);
      
      // Sort levels by upper bound to determine position
      const sortedByUpper = [...this.certificateLevels].sort((a, b) => 
        Number(b.upperBoundRange) - Number(a.upperBoundRange)
      );
      
      const isFirstLevel = sortedByUpper[0] === deletedLevel; // Highest upper bound
      const isLastLevel = sortedByUpper[sortedByUpper.length - 1] === deletedLevel; // Lowest upper bound
      
      // Remove the level
      this.certificateLevels.splice(index, 1);
      
      if (isFirstLevel) {
        // If deleted on first level, find the next level (level below it) and set upper bound to 100
        let nextLevel = null;
        for (let i = 0; i < this.certificateLevels.length; i++) {
          const level = this.certificateLevels[i];
          const levelUpper = Number(level.upperBoundRange);
          
          if (levelUpper < deletedLower) {
            if (!nextLevel || levelUpper > Number(nextLevel.upperBoundRange)) {
              nextLevel = level;
            }
          }
        }
        
        if (nextLevel) {
          nextLevel.upperBoundRange = 100;
        }
      } else if (!isLastLevel) {
        // If deleted on middle level, find the next level (level below it) and extend its upper bound to deleted level's upper bound
        let nextLevel = null;
        for (let i = 0; i < this.certificateLevels.length; i++) {
          const level = this.certificateLevels[i];
          const levelUpper = Number(level.upperBoundRange);
          
          if (levelUpper < deletedLower) {
            if (!nextLevel || levelUpper > Number(nextLevel.upperBoundRange)) {
              nextLevel = level;
            }
          }
        }
        
        if (nextLevel) {
          nextLevel.upperBoundRange = deletedUpper;
        }
      }
      // If deleted on last level, do nothing (other levels stay the same)
      
      this.updateCertificateLevels();
    },

    async updateCertificateLevels() {
      if (this.hasValidationErrors()) {
        console.log('Validation errors present, not updating');
        return;
      }
      
      await this.updateCourseCertificateLevels({
        courseId: this.courseId, 
        payload: {
          conditions: this.certificateLevels
        }
      }).then(() => {});

      await this.getCourseInfo({
        courseId: this.courseId,
        temp: true,
        excepts: "numberOfStudent,numberOfActiveStudent"
      });
      
      this.$emit('certificate-levels-updated', this.certificateLevels);
    },

    async handleCertificateLevels() {
      this.certificateLevels = null;
      if (this.useCertificateLevels && this.pdfAction && this.posttestLectureName) {
        this.certificateLevels = [
          {
            index: 1,
            certLevel: "PLATINUM",
            upperBoundRange: 100,
            lowerBoundRange: 60,
          }
        ];
      }

      this.updateCertificateLevels();
    },
  },
};
</script>

<style scoped>
.not-have-post-test {
    color: orange;
    width: 100%;
    padding: 0.75rem 1.25rem;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 0.25rem;
}

.invalid {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>
